import React, { useState, useEffect } from 'react'
import List from './List'
import Add from './Add'
export default function main() {
    const [tab, setTab] = useState('list');
    const [Editdata, setEditdata] = useState({});

    const handleEdit = (type) => {
        setTab(type)
    }
    return (
        <>
            <div style={{margin:'20px 0 30px 20px',display:'flex',gap:'10px'}}>
                <button style={{padding:'10px',borderRadius:'5px',background: tab =="list" ? "#337ab7" : '#f4f3f1',height:'40px',width:'40px',color:tab =="list" ? "#fff" :'#000'}} onClick={()=>handleEdit("list")}><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                <button style={{padding:'10px',borderRadius:'5px',background: tab =="add" ? "#337ab7" : '#f4f3f1',height:'40px',width:'40px',color: tab =="add" ? "#fff" :'#000'}} onClick={()=>handleEdit("add")}><i class="fa fa-plus" aria-hidden="true"></i></button>
            </div>
            {
                tab == "list" ? <List handleEdit={handleEdit} /> : ""
            }
            {
                tab == "add" ? <Add handleEdit={handleEdit} Editdata={Editdata} /> : ""
            }

        </>
    )
}
